export enum GaTrackingEventCategory {
  Navigation = 'Navigation',
  Interaction = 'Interaction',
  Ecommerce = 'Ecommerce',
  Errors = 'Errors',
  Product = 'Product',
  SearchTerm = 'Search Term',
  Category = 'Category',
  Authorisation = 'Authorisation',
  Optimizely = 'Optimizely',
  OrderHistorySideMenu = 'interaction',
  Notifications = 'Notifications',
  YourAssortment = 'your assortment',
  ShoppingListV2 = 'shopping list',
  ImageSearch = 'image_search',
  OrdersHistory = 'order history',
}
